import React, { useEffect, useRef, useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import { Button, InputAdornment } from "@material-ui/core";
import downloadWhite from "images/downloadWhite.svg";
import { CustomTextField } from "containers/gstr2a2bNewEnhancement/Utility/utility";
import Table from "./Table";
import { useDispatch, useSelector } from "react-redux";
import { errorToastMessage } from "utils/errorToast";
import { GSTR2A2BNEW_MSGS } from "Constant/Messages";
import {
  downloadRecoReportExcel,
  getRecoTablesData,
  setDocDateTableData,
} from "../action";

const RecoReport = (props) => {
  const dispatch = useDispatch();
  const debounceTimeout = useRef(null);
  const [search, setSearch] = useState("");
  const { docDateTableData } = useSelector(
    (store) => store.gstr2a2bNewRecoReducer
  );
  const handleDownload = () => {
    if (docDateTableData?.length > 0) {
      dispatch(downloadRecoReportExcel(docDateTableData));
    } else {
      errorToastMessage(GSTR2A2BNEW_MSGS.NO_DOWNLOAD);
    }
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setSearch(value);
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      props.handleSubmit(false, value);
    }, 500);
  };

  useEffect(() => {
    return () => dispatch(setDocDateTableData([]));
  }, []);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-start" }}>
        <div style={{ width: "35%" }}>
          <CustomTextField
            style={{ backgroundColor: "white" }}
            placeholder="Search"
            variant="outlined"
            size="small"
              value={search}
            onChange={handleInputChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>

        <Button
          onClick={handleDownload}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "5px",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          <img
            src={downloadWhite}
            alt="Download"
            style={{
              width: "30px",
              height: "20px",
              paddingBottom: "3px",
            }}
          />
          Download
        </Button>
      </div>
      <Table />
    </>
  );
};

export default RecoReport;
